import React, { useState } from 'react';
import { Button, Form, Offcanvas } from "react-bootstrap";
import MultiSelect from '../../components/MultiSelect';
import { Badge, Tab, Nav, Table, ListGroup } from 'react-bootstrap';
import DataTable from "react-data-table-component";
import { customTableStyles } from "../../utils";
import SearchSelect from '../../components/SearchSelect';
import { Link } from 'react-router-dom'
import AlertCreateModal from './AlertModal';

const DriverViewSide = ({ show, close }) => {
    const [activeTab, setActiveTab] = useState('alerts');
    const [key, setKey] = useState('home');
    const columns = [
        {
            name: 'Job Date',
            selector: row => row.jobDate,
            sortable: true,
        },
        {
            name: 'Job Created',
            selector: row => row.jobCreated,
            sortable: true,
        },
        {
            name: 'Origin',
            selector: row => row.origin,
            sortable: true,
        },
        {
            name: 'Delivery',
            selector: row => row.delivery,
            sortable: true,
        },
        {
            name: 'C Number',
            selector: row => row.cNumber,
            sortable: true,
        },
        {
            name: 'Broker',
            selector: row => row.broker,
            sortable: true,
        },
        {
            name: 'Amount',
            selector: row => row.amount,
            sortable: true,
        },
        {
            name: 'Expense Date',
            selector: row => row.expenseDate,
            sortable: true,
        },
        {
            name: 'Expense Amount',
            selector: row => row.expenseAmount,
            sortable: true,
        },
        {
            name: 'Expense Details',
            selector: row => row.expenseDetails,
            sortable: true,
        },
        {
            name: 'Expense Type',
            selector: row => row.expenseType,
            sortable: true,
        },
        {
            name: 'Paid Date',
            selector: row => row.paidDate,
            sortable: true,
        },
        {
            name: 'Driver Selection',
            selector: row => row.driverSelection,
            sortable: true,
        },
        {
            name: 'Weekly Jobs',
            selector: row => row.weeklyJobs,
            sortable: true,
        },
        {
            name: 'Action',
            cell: (row, i) => {
                return (
                    <div className="hstack gap-1 fs-1">
                        <button
                            aria-label="view"
                            // onClick={() => setIsView(true)}
                            className="btn btn-icon btn-sm btn-primary-light btn-wave waves-effect waves-light"
                        >
                            <i className="ri-eye-fill" />
                        </button>
                        <button
                            aria-label="edit"
                            // onClick={() => setIsEdit(true)}
                            className="btn btn-icon btn-sm btn-info-light btn-wave waves-effect waves-light"
                        >
                            <i className="ri-edit-line" />
                        </button>
                        <a
                            aria-label="delete"
                            href="javascript:void(0);"

                            className="btn btn-icon btn-sm btn-danger-light btn-wave waves-effect waves-light"
                        >
                            <i className="ri-delete-bin-7-line" />
                        </a>
                    </div>
                );
            },
            ignoreRowClick: true,
            allowOverflow: true,
            button: true,
        },
    ];
    const data = [
        {
            id: 1,
            jobDate: '2024-09-01',
            jobCreated: '2024-08-30',
            origin: 'New York',
            delivery: 'Los Angeles',
            cNumber: 'C12345',
            broker: 'Broker A',
            amount: 1500,
            expenseDate: '2024-09-02',
            expenseAmount: 200,
            expenseDetails: 'Fuel cost for delivery',
            expenseType: 'Fuel',
            paidDate: '2024-09-03',
            driverSelection: 'John Doe',
            weeklyJobs: 5,
        },
        {
            id: 2,
            jobDate: '2024-09-02',
            jobCreated: '2024-08-31',
            origin: 'Chicago',
            delivery: 'Miami',
            cNumber: 'C12346',
            broker: 'Broker B',
            amount: 1800,
            expenseDate: '2024-09-03',
            expenseAmount: 250,
            expenseDetails: 'Tolls and fees',
            expenseType: 'Factoring',
            paidDate: '2024-09-04',
            driverSelection: 'Jane Smith',
            weeklyJobs: 6,
        },
        {
            id: 3,
            jobDate: '2024-09-03',
            jobCreated: '2024-09-01',
            origin: 'Houston',
            delivery: 'Atlanta',
            cNumber: 'C12347',
            broker: 'Broker C',
            amount: 2000,
            expenseDate: '2024-09-04',
            expenseAmount: 300,
            expenseDetails: 'Service charge',
            expenseType: 'Service',
            paidDate: '2024-09-05',
            driverSelection: 'Mike Johnson',
            weeklyJobs: 4,
        },
        {
            id: 4,
            jobDate: '2024-09-04',
            jobCreated: '2024-09-02',
            origin: 'Los Angeles',
            delivery: 'Seattle',
            cNumber: 'C12348',
            broker: 'Broker D',
            amount: 2500,
            expenseDate: '2024-09-05',
            expenseAmount: 400,
            expenseDetails: 'Parking fees',
            expenseType: 'Parking',
            paidDate: '2024-09-06',
            driverSelection: 'Alice Brown',
            weeklyJobs: 3,
        },
        {
            id: 5,
            jobDate: '2024-09-05',
            jobCreated: '2024-09-03',
            origin: 'Miami',
            delivery: 'Orlando',
            cNumber: 'C12349',
            broker: 'Broker E',
            amount: 2200,
            expenseDate: '2024-09-06',
            expenseAmount: 150,
            expenseDetails: 'Toll costs',
            expenseType: 'Toll',
            paidDate: '2024-09-07',
            driverSelection: 'Chris Green',
            weeklyJobs: 7,
        },
        {
            id: 6,
            jobDate: '2024-09-06',
            jobCreated: '2024-09-04',
            origin: 'Phoenix',
            delivery: 'Denver',
            cNumber: 'C12350',
            broker: 'Broker F',
            amount: 1700,
            expenseDate: '2024-09-07',
            expenseAmount: 100,
            expenseDetails: 'Miscellaneous expenses',
            expenseType: 'Misc',
            paidDate: '2024-09-08',
            driverSelection: 'Eve White',
            weeklyJobs: 8,
        },
        {
            id: 7,
            jobDate: '2024-09-07',
            jobCreated: '2024-09-05',
            origin: 'San Francisco',
            delivery: 'Las Vegas',
            cNumber: 'C12351',
            broker: 'Broker G',
            amount: 1600,
            expenseDate: '2024-09-08',
            expenseAmount: 350,
            expenseDetails: 'Fuel and lodging',
            expenseType: 'Fuel',
            paidDate: '2024-09-09',
            driverSelection: 'Jack Black',
            weeklyJobs: 5,
        },
        {
            id: 8,
            jobDate: '2024-09-08',
            jobCreated: '2024-09-06',
            origin: 'Dallas',
            delivery: 'Austin',
            cNumber: 'C12352',
            broker: 'Broker H',
            amount: 1300,
            expenseDate: '2024-09-09',
            expenseAmount: 200,
            expenseDetails: 'Delivery charges',
            expenseType: 'Delivery',
            paidDate: '2024-09-10',
            driverSelection: 'Sam Gray',
            weeklyJobs: 2,
        },
        {
            id: 9,
            jobDate: '2024-09-09',
            jobCreated: '2024-09-07',
            origin: 'Atlanta',
            delivery: 'Charlotte',
            cNumber: 'C12353',
            broker: 'Broker I',
            amount: 1900,
            expenseDate: '2024-09-10',
            expenseAmount: 280,
            expenseDetails: 'Fuel for trip',
            expenseType: 'Fuel',
            paidDate: '2024-09-11',
            driverSelection: 'Nancy Blue',
            weeklyJobs: 9,
        },
        {
            id: 10,
            jobDate: '2024-09-10',
            jobCreated: '2024-09-08',
            origin: 'Seattle',
            delivery: 'Portland',
            cNumber: 'C12354',
            broker: 'Broker J',
            amount: 2100,
            expenseDate: '2024-09-11',
            expenseAmount: 320,
            expenseDetails: 'Overnight stay',
            expenseType: 'Lodging',
            paidDate: '2024-09-12',
            driverSelection: 'Olivia Red',
            weeklyJobs: 1,
        },
        {
            id: 11,
            jobDate: '2024-09-11',
            jobCreated: '2024-09-09',
            origin: 'Boston',
            delivery: 'New York',
            cNumber: 'C12355',
            broker: 'Broker K',
            amount: 1200,
            expenseDate: '2024-09-12',
            expenseAmount: 150,
            expenseDetails: 'Fuel and food',
            expenseType: 'Food',
            paidDate: '2024-09-13',
            driverSelection: 'Lucas White',
            weeklyJobs: 4,
        },
        {
            id: 12,
            jobDate: '2024-09-12',
            jobCreated: '2024-09-10',
            origin: 'San Diego',
            delivery: 'Las Vegas',
            cNumber: 'C12356',
            broker: 'Broker L',
            amount: 2200,
            expenseDate: '2024-09-13',
            expenseAmount: 400,
            expenseDetails: 'Fuel and service fees',
            expenseType: 'Fuel',
            paidDate: '2024-09-14',
            driverSelection: 'Zoe Black',
            weeklyJobs: 6,
        },
        {
            id: 13,
            jobDate: '2024-09-13',
            jobCreated: '2024-09-11',
            origin: 'Miami',
            delivery: 'Atlanta',
            cNumber: 'C12357',
            broker: 'Broker M',
            amount: 1700,
            expenseDate: '2024-09-14',
            expenseAmount: 100,
            expenseDetails: 'Miscellaneous',
            expenseType: 'Misc',
            paidDate: '2024-09-15',
            driverSelection: 'Max Green',
            weeklyJobs: 3,
        },
    ];


    const [isChecked, setIsChecked] = useState(false);
    const [isShow, setIsShow] = useState(false);

    const handleCheckboxChange = () => {
        setIsChecked(!isChecked);
        setIsShow(true);
    };

    const columns1 = [
        {
            name: 'User',
            selector: row => row.user,
            sortable: true,
        },
        {
            name: 'Edit Timestamp',
            selector: row => row.editTimestamp,
            sortable: true,
        },
        {
            name: 'Actions',
            cell: (row, i) => {
                return (
                    <div className="hstack gap-1 fs-1">
                        <Button
                            aria-label="View Details"
                            onClick={() => alert(`Viewing details for ${row.user}`)}
                            className="btn btn-icon btn-sm btn-info-light btn-wave waves-effect waves-light"
                        >
                            <i className="ri-eye-line" />
                        </Button>
                    </div>
                )
            },
            ignoreRowClick: true,
            allowOverflow: true,
            button: true,
        },
    ];

    const data1 = [
        {
            user: 'User A',
            editTimestamp: '2024-09-01T10:45:00',
        },
        {
            user: 'User B',
            editTimestamp: '2024-09-05T14:30:00',
        },
        {
            user: 'User C',
            editTimestamp: '2024-09-10T09:20:00',
        },
        {
            user: 'User D',
            editTimestamp: '2024-09-12T16:10:00',
        },
        {
            user: 'User E',
            editTimestamp: '2024-09-14T11:50:00',
        },
        {
            user: 'User F',
            editTimestamp: '2024-09-18T13:05:00',
        },
        {
            user: 'User G',
            editTimestamp: '2024-09-20T15:25:00',
        },
        {
            user: 'User H',
            editTimestamp: '2024-09-22T08:40:00',
        },
        {
            user: 'User I',
            editTimestamp: '2024-09-25T12:35:00',
        },
        {
            user: 'User J',
            editTimestamp: '2024-09-28T10:15:00',
        },
    ];


    const columns3 = [
        {
            name: 'Name',
            selector: row => row.name,
            sortable: true,
        },
        {
            name: 'Alert 1 Date',
            selector: row => row.alert1Date,
            sortable: true,
        },
        {
            name: 'Alert 2 Date',
            selector: row => row.alert2Date,
            sortable: true,
        },
        {
            name: 'Alert 3 Date',
            selector: row => row.alert3Date,
            sortable: true,
        }
    ];
    const data3 = [
        {
            name: 'Driver 1',
            alert1Date: '2024-03-10T09:00:00',
            alert2Date: '2024-03-15T12:30:00',
            alert3Date: '2024-03-20T14:45:00',
        },
        {
            name: 'Driver 2',
            alert1Date: '2024-03-12T11:15:00',
            alert2Date: '2024-03-18T10:45:00',
            alert3Date: '2024-03-25T13:00:00',
        },
        {
            name: 'Driver 3',
            alert1Date: '2024-03-14T10:30:00',
            alert2Date: '2024-03-20T09:15:00',
            alert3Date: '2024-03-28T16:00:00',
        },
        {
            name: 'Driver 1',
            alert1Date: '2024-03-10T09:00:00',
            alert2Date: '2024-03-15T12:30:00',
            alert3Date: '2024-03-20T14:45:00',
        },
        {
            name: 'Driver 2',
            alert1Date: '2024-03-12T11:15:00',
            alert2Date: '2024-03-18T10:45:00',
            alert3Date: '2024-03-25T13:00:00',
        },
        {
            name: 'Driver 3',
            alert1Date: '2024-03-14T10:30:00',
            alert2Date: '2024-03-20T09:15:00',
            alert3Date: '2024-03-28T16:00:00',
        },
        {
            name: 'Driver 1',
            alert1Date: '2024-03-10T09:00:00',
            alert2Date: '2024-03-15T12:30:00',
            alert3Date: '2024-03-20T14:45:00',
        },
        {
            name: 'Driver 2',
            alert1Date: '2024-03-12T11:15:00',
            alert2Date: '2024-03-18T10:45:00',
            alert3Date: '2024-03-25T13:00:00',
        },
        {
            name: 'Driver 3',
            alert1Date: '2024-03-14T10:30:00',
            alert2Date: '2024-03-20T09:15:00',
            alert3Date: '2024-03-28T16:00:00',
        },
        {
            name: 'Driver 1',
            alert1Date: '2024-03-10T09:00:00',
            alert2Date: '2024-03-15T12:30:00',
            alert3Date: '2024-03-20T14:45:00',
        },
        {
            name: 'Driver 2',
            alert1Date: '2024-03-12T11:15:00',
            alert2Date: '2024-03-18T10:45:00',
            alert3Date: '2024-03-25T13:00:00',
        },
        {
            name: 'Driver 3',
            alert1Date: '2024-03-14T10:30:00',
            alert2Date: '2024-03-20T09:15:00',
            alert3Date: '2024-03-28T16:00:00',
        },
        {
            name: 'Driver 1',
            alert1Date: '2024-03-10T09:00:00',
            alert2Date: '2024-03-15T12:30:00',
            alert3Date: '2024-03-20T14:45:00',
        },
        {
            name: 'Driver 2',
            alert1Date: '2024-03-12T11:15:00',
            alert2Date: '2024-03-18T10:45:00',
            alert3Date: '2024-03-25T13:00:00',
        },
        {
            name: 'Driver 3',
            alert1Date: '2024-03-14T10:30:00',
            alert2Date: '2024-03-20T09:15:00',
            alert3Date: '2024-03-28T16:00:00',
        },
        {
            name: 'Driver 1',
            alert1Date: '2024-03-10T09:00:00',
            alert2Date: '2024-03-15T12:30:00',
            alert3Date: '2024-03-20T14:45:00',
        },
        {
            name: 'Driver 2',
            alert1Date: '2024-03-12T11:15:00',
            alert2Date: '2024-03-18T10:45:00',
            alert3Date: '2024-03-25T13:00:00',
        },
        {
            name: 'Driver 3',
            alert1Date: '2024-03-14T10:30:00',
            alert2Date: '2024-03-20T09:15:00',
            alert3Date: '2024-03-28T16:00:00',
        },
        // Additional data entries...
    ];
    return (
        <>
            <Offcanvas show={show} className="canvas-lg bg-light " onHide={close} placement="end">
                <Offcanvas.Header>
                    <Offcanvas.Title>
                        Application Details
                    </Offcanvas.Title>
                    <button className="btn-close" onClick={close}><i className="ri-close-line"></i></button>
                </Offcanvas.Header>
                <Offcanvas.Body>
                    <div className="row">
                        <div className="col-md-12 mx-auto">
                            <div className="card border shadow-sm mb-3 ">
                                <div className="card-header text-center d-flex justify-content-between">
                                    <h4>Application Form</h4>
                                    <button className="text-white px-5  btn btn-primary" data-form-type="">Edit</button>
                                </div>
                            </div>

                        </div>

                    </div>

                    <Tab.Container id="left-tabs-example" defaultActiveKey="personal-info">
                        <div className="">
                            <div className="row">
                                <div className=" col-md-3 h-100 sticky-card">
                                    <div className="card p-4">
                                        <Nav variant="pills" className="gap-2">
                                            <Nav.Item className='w-100'>
                                                <Nav.Link eventKey="personal-info" className='w-100'>
                                                    Personal Information
                                                </Nav.Link>
                                            </Nav.Item>
                                            <Nav.Item className='w-100'>
                                                <Nav.Link eventKey="drivers-license-info" className='w-100'>
                                                    Application Form
                                                </Nav.Link>
                                            </Nav.Item>
                                            <Nav.Item className='w-100'>
                                                <Nav.Link eventKey="jobs" className='w-100'>
                                                    Trips
                                                </Nav.Link>
                                            </Nav.Item>
                                            <Nav.Item className='w-100'>
                                                <Nav.Link eventKey="driver-alerts" className='w-100'>
                                                    Drivers Alerts
                                                </Nav.Link>
                                            </Nav.Item>
                                            <Nav.Item className='w-100'>
                                                <Nav.Link eventKey="application-history" className='w-100'>
                                                    Application History
                                                </Nav.Link>
                                            </Nav.Item>

                                        </Nav>
                                    </div>
                                </div>
                                <div className="h-100 p-0 col-md-9 pe-5">
                                    <div className="card h-100 px-5 py-5">
                                        <Tab.Content>
                                            <Tab.Pane eventKey="personal-info">
                                                <div className="single-data mt-2">
                                                    <h5 className="text-cen3er">Personal Information</h5>
                                                    <div className="row mt-3">
                                                        <div className="col-lg-3">
                                                            <div className="mb-2">
                                                                <label className="form-label">Full Name</label>
                                                                <p>Muhammad Usama</p>
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-3">
                                                            <div className="mb-2">
                                                                <label className="form-label">Date of Birth</label>
                                                                <p>29-jan-200</p>
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-3">
                                                            <div className="mb-2">
                                                                <label className="form-label">Phone Number:</label>
                                                                <p>+923456413071</p>
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-3">
                                                            <div className="mb-2">
                                                                <label className="form-label">Email:</label>
                                                                <p>usamaasif4190@gmail.com</p>
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-12">
                                                            <div className="mb-2">
                                                                <label className="form-label">Home Address:</label>
                                                                <p>70 Second Court, Unde vitae consequun, Occaecat delectus p, Connecticut 82307, USA - 667 years</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </Tab.Pane>
                                            <Tab.Pane eventKey="drivers-license-info">
                                                <div className="single-data mt-2">
                                                    <h5 className="text-left">Driver’s License Information</h5>
                                                    <div className="row mt-3">
                                                        <div className="col-lg-3">
                                                            <div className="mb-2">
                                                                <label className="form-label">Driver’s License Number</label>
                                                                <p>123456789</p>
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-3">
                                                            <div className="mb-2">
                                                                <label className="form-label">State of Issuance:</label>
                                                                <p>California</p>
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-3">
                                                            <div className="mb-2">
                                                                <label className="form-label">License Class:</label>
                                                                <p>Class C</p>
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-3">
                                                            <div className="mb-2">
                                                                <label className="form-label">Status:</label>
                                                                <p>Active</p>
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-3">
                                                            <div className="mb-2">
                                                                <label className="form-label">Restrictions:</label>
                                                                <p>None</p>
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-3">
                                                            <div className="mb-2">
                                                                <label className="form-label">Endorsements:</label>
                                                                <p>None</p>
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-3">
                                                            <div className="mb-2">
                                                                <label className="form-label">Issue Date:</label>
                                                                <p>01/01/2020</p>
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-3">
                                                            <div className="mb-2">
                                                                <label className="form-label">Expiration Date:</label>
                                                                <p className='mb-0'>01/01/2025</p>
                                                                <Form.Group className="mb-3 d-flex align-items-center">
                                                                    <Form.Check type="checkbox" checked={isChecked} onChange={handleCheckboxChange} className="me-2" />
                                                                    <Form.Label className='mt-1'>Add Expiry</Form.Label>
                                                                </Form.Group>

                                                            </div>
                                                        </div>
                                                        <div className="col-lg-3">
                                                            <div className="mb-2">
                                                                <label className="form-label">Upload Copy of Driver's License:</label>
                                                                <p>Uploaded</p>
                                                            </div>
                                                        </div>
                                                    </div>

                                                </div>
                                                <div className="single-data mt-2">
                                                    <h5 className="text-left">Drug Test Information</h5>
                                                    <div className="row mt-3">
                                                        <div className="col-lg-3">
                                                            <div className="mb-2">
                                                                <label className="form-label">Date of Last Drug Test:</label>
                                                                <p>08/20/2024</p>
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-3">
                                                            <div className="mb-2">
                                                                <label className="form-label">Drug Test Result:</label>
                                                                <p>Negative</p>
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-3">
                                                            <div className="mb-2">
                                                                <label className="form-label">Drug Test Provider Name:</label>
                                                                <p>HealthCheck Labs</p>
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-3">
                                                            <div className="mb-2">
                                                                <label className="form-label">Facility Contact Information:</label>
                                                                <p>(555) 123-4567</p>
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-3">
                                                            <div className="mb-2">
                                                                <label className="form-label">Link to Government Clearinghouse:</label>
                                                                <p><a href="https://www.example.com/clearinghouse">https://www.example.com/clearinghouse</a></p>
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-3">
                                                            <div className="mb-2">
                                                                <label className="form-label">Consent for Drug Test Result Submission:</label>
                                                                <p>Granted</p>
                                                            </div>
                                                        </div>
                                                    </div>

                                                </div>
                                                <div className="single-data mt-2">
                                                    <h5 className="text-left">Pre-Employment Information</h5>
                                                    <div className="row mt-3">
                                                        <div className="col-lg-3">
                                                            <div className="mb-2">
                                                                <label className="form-label">Employer Name:</label>
                                                                <p>ABC Corp</p>
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-3">
                                                            <div className="mb-2">
                                                                <label className="form-label">Job Title:</label>
                                                                <p>Software Engineer</p>
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-3">
                                                            <div className="mb-2">
                                                                <label className="form-label">Start Date:</label>
                                                                <p>01/15/2020</p>
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-3">
                                                            <div className="mb-2">
                                                                <label className="form-label">End Date:</label>
                                                                <p className='mb-0'>08/31/2023</p>
                                                                <Form.Group className="mb-3 d-flex align-items-center">
                                                                    <Form.Check type="checkbox" checked={isChecked} onChange={handleCheckboxChange} className="me-2" />
                                                                    <Form.Label className='mt-1'>Add Expiry</Form.Label>
                                                                </Form.Group>
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-3">
                                                            <div className="mb-2">
                                                                <label className="form-label">Reason for Leaving:</label>
                                                                <p>Seeking new opportunities</p>
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-3">
                                                            <div className="mb-2">
                                                                <label className="form-label">Pre-Employment Drug Test Date:</label>
                                                                <p>01/10/2020</p>
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-3">
                                                            <div className="mb-2">
                                                                <label className="form-label">References:</label>
                                                                <p>Jane Doe - (555) 987-6543</p>
                                                                <p>John Smith - (555) 654-3210</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="single-data mt-2">
                                                    <h5 className="text-left">Social Security Information</h5>
                                                    <div className="row mt-3">
                                                        <div className="col-lg-3">
                                                            <div className="mb-2">
                                                                <label className="form-label">Social Security Number:</label>
                                                                <p>123-45-6789</p>
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-3">
                                                            <div className="mb-2">
                                                                <label className="form-label">Consent for Social Security Verification:</label>
                                                                <p>Granted</p>
                                                            </div>
                                                        </div>
                                                    </div>

                                                </div>
                                                <div className="single-data mt-2">
                                                    <h5 className="text-left">Motor Vehicle Record (MVR)</h5>
                                                    <div className="row mt-3">
                                                        <div className="col-lg-3">
                                                            <div className="mb-2">
                                                                <label className="form-label">Authorization for MVR Check:</label>
                                                                <p>Authorized</p>
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-3">
                                                            <div className="mb-2">
                                                                <label className="form-label">Driver’s License Number:</label>
                                                                <p>123456789</p>
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-3">
                                                            <div className="mb-2">
                                                                <label className="form-label">State of Issue:</label>
                                                                <p>California</p>
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-3">
                                                            <div className="mb-2">
                                                                <label className="form-label">MVR Expiration Date:</label>
                                                                <p className='mb-0'>09/15/2025</p>
                                                                <Form.Group className="mb-3 d-flex align-items-center">
                                                                    <Form.Check type="checkbox" checked={isChecked} onChange={handleCheckboxChange} className="me-2" />
                                                                    <Form.Label className='mt-1'>Add Expiry</Form.Label>
                                                                </Form.Group>
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-3">
                                                            <div className="mb-2">
                                                                <label className="form-label">Upload MVR Report:</label>
                                                                <p>Uploaded</p>
                                                            </div>
                                                        </div>
                                                    </div>

                                                </div>
                                                <div className="single-data mt-2">
                                                    <h5 className="text-left">Consent and Legal Agreements</h5>
                                                    <div className="row mt-3">
                                                        <div className="col-lg-3">
                                                            <div className="mb-2">
                                                                <label className="form-label">Consent for Background Check:</label>
                                                                <p>Granted</p>
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-3">
                                                            <div className="mb-2">
                                                                <label className="form-label">Consent for Drug Testing:</label>
                                                                <p>Granted</p>
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-3">
                                                            <div className="mb-2">
                                                                <label className="form-label">Consent for Social Security Verification:</label>
                                                                <p>Granted</p>
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-3">
                                                            <div className="mb-2">
                                                                <label className="form-label">Consent to MVR Check:</label>
                                                                <p>Granted</p>
                                                            </div>
                                                        </div>
                                                    </div>

                                                </div>
                                                <div className="single-data mt-2">
                                                    <h5 className="text-left">Optional Uploads</h5>
                                                    <div className="row mt-3">
                                                        <div className="col-lg-4">
                                                            <div className="mb-2">
                                                                <label className="form-label">Upload Copy of Medical Examiner's Certificate:</label>
                                                                <p><img src="https://via.placeholder.com/150x150" alt="Medical Examiner's Certificate" /></p>
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-4">
                                                            <div className="mb-2">
                                                                <label className="form-label">Upload Copy of MVR Report:</label>
                                                                <p><img src="https://via.placeholder.com/150x150" alt="MVR Report" /></p>
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-4">
                                                            <div className="mb-2">
                                                                <label className="form-label">Upload Copy of Social Security Card:</label>
                                                                <p><img src="https://via.placeholder.com/150x150" alt="Social Security Card" /></p>
                                                            </div>
                                                        </div>
                                                    </div>

                                                </div>
                                                <div className="single-data mt-2">
                                                    <h5 className="text-left">Emergency Contact Information</h5>
                                                    <div className="row mt-3">
                                                        <div className="col-lg-3">
                                                            <div className="mb-2">
                                                                <label className="form-label">Name:</label>
                                                                <p>John Doe</p>
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-3">
                                                            <div className="mb-2">
                                                                <label className="form-label">Relationship:</label>
                                                                <p>Friend</p>
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-3">
                                                            <div className="mb-2">
                                                                <label className="form-label">Phone Number:</label>
                                                                <p>(555) 123-4567</p>
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-3">
                                                            <div className="mb-2">
                                                                <label className="form-label">Email:</label>
                                                                <p>johndoe@example.com</p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className="single-data mt-2">
                                                    <h5 className="text-left">Medical Information (DOT Physical Exam)</h5>
                                                    <div className="row mt-3">
                                                        <div className="col-lg-4">
                                                            <div className="mb-2">
                                                                <label className="form-label">Medical Examiner's Certificate Number:</label>
                                                                <p>ME123456789</p>
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-4">
                                                            <div className="mb-2">
                                                                <label className="form-label">Medical Examination Date:</label>
                                                                <p>08/20/2024</p>
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-4">
                                                            <div className="mb-2">
                                                                <label className="form-label">Expiration Date of Medical Certificate:</label>
                                                                <p className='mb-0'>08/20/2025</p>
                                                                <Form.Group className="mb-3 d-flex align-items-center">
                                                                    <Form.Check type="checkbox" checked={isChecked} onChange={handleCheckboxChange} className="me-2" />
                                                                    <Form.Label className='mt-1'>Add Expiry</Form.Label>
                                                                </Form.Group>
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-4">
                                                            <div className="mb-2">
                                                                <label className="form-label">Medical Examiner’s Name:</label>
                                                                <p>Dr. Jane Smith</p>
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-4">
                                                            <div className="mb-2">
                                                                <label className="form-label">Medical Examiner’s Contact Information:</label>
                                                                <p>(555) 987-6543</p>
                                                            </div>
                                                        </div>
                                                        <div className="col-lg-4">
                                                            <div className="mb-2">
                                                                <label className="form-label">Expiration Notification:</label>
                                                                <div>
                                                                    <input type="checkbox" id="expirationNotification" />
                                                                    <label htmlFor="expirationNotification"> Receive reminders</label>
                                                                </div>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </Tab.Pane>
                                            <Tab.Pane eventKey="jobs">
                                                <div className="single-data mt-2">
                                                    <h5 className="text-left">Trips</h5>
                                                    <DataTable
                                                        columns={columns}
                                                        data={data}
                                                        customStyles={customTableStyles}
                                                        pagination={true}
                                                    />
                                                </div>
                                            </Tab.Pane>
                                            <Tab.Pane eventKey="driver-alerts">
                                                <div className="single-data mt-2">
                                                    <h5 className="text-left">Driver Alerts</h5>
                                                    <DataTable
                                                        columns={columns3}
                                                        data={data3}
                                                        customStyles={customTableStyles}
                                                        pagination={true}
                                                    />
                                                </div>
                                            </Tab.Pane>
                                            <Tab.Pane eventKey="application-history">
                                                <div className="single-data mt-2">
                                                    <h5 className="text-left">Application History</h5>
                                                    <DataTable
                                                        columns={columns1}
                                                        data={data1}
                                                        customStyles={customTableStyles}
                                                        pagination={true}
                                                    />
                                                </div>
                                            </Tab.Pane>
                                        </Tab.Content>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </Tab.Container>
                </Offcanvas.Body>
                {/* <Offcanvas.Header>
                    <div className="col-6">
                        <Button variant="primary" className="text-white w-100 fw-bold">
                            Reset
                        </Button>
                    </div>
                    <div className="col-6">
                        <Button variant="primary" onClick={close} className="text-white w-100 fw-bold">
                            Filter
                        </Button>
                    </div>
                </Offcanvas.Header> */}
            </Offcanvas >
            <AlertCreateModal
                show={isShow}
                handleClose={() => setIsShow(false)}
            />
        </>
    );
};

export default DriverViewSide;